/**
 * Central registry of feature gate keys used in the application.
 * Add new feature gate keys here as string constants.
 */
export const featureGateKeys = {
  /**
   * COMMUNITY_APP_UPDATES
   * @link https://switcheroo.atlassian.com/ui/gates/e721eb2d-646b-4905-a21d-9060f599cb3a/key/community-app-updates
   * @description Controls visibility of the /updates page. When off, users are
   * redirected to the community home page.
   * @returns true if the App Updates UI should be shown
   */
  publicAppUpdatesUi: 'community-app-updates',
  /**
   * COMMUNITY_RELEASE_NOTES_PAGE
   * @link https://switcheroo.atlassian.com/ui/gates/13529843-7c40-4813-91b2-948c37fe4771/key/community-release-notes-page
   * @description Controls page redirect. When off, users are redirected to the
   * community home page.
   * @returns true if the release notes page should be shown
   */
  communityReleaseNotesPage: 'community-release-notes-page',
} as const;

export type FeatureGateValue =
  (typeof featureGateKeys)[keyof typeof featureGateKeys];
